import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import { thunk } from "redux-thunk";

// Your slices
import userReducer from "../Slices/UserSlice";
import appRequest from "../Slices/AppRequestSlice";
import usbLoadingReducer from "../Slices/UsbLoadingSlice";
import syncLoadingReducer from "../Slices/SyncLoadingSlice";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  appRequests: appRequest,
  usbLoading: usbLoadingReducer,
  syncLoading: syncLoadingReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: true }),
  //   middleware: [thunk],
})

export const persistor = persistStore(store)
